import React from 'react';
import { Navigate } from 'react-router-dom';

const RequireAuth = ({ children }) => {
  const storedUser = localStorage.getItem('loggedInUser');

  if (!storedUser) {
    return <Navigate to="/login" replace />;
  }

  let user;
  try {
    user = JSON.parse(storedUser);
  } catch (e) {
    localStorage.removeItem("loggedInUser");
    return <Navigate to="/login" replace />;
  }

  const now = Date.now();
  const loginTime = user.loginTime;

  // Logout if loginTime is missing or expired
  const twentyFourHours = 24 * 60 * 60 * 1000;
  if (!loginTime || now - loginTime > twentyFourHours) {
    localStorage.removeItem("loggedInUser");
    return <Navigate to="/" replace />;
  }

  return children;
};

export default RequireAuth;
